(() => {
  const boot = root => {
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const scenes = [...root.querySelectorAll('[data-studio-scene]')];
    if (!scenes.length) return;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController(), options = {signal:abort.signal};
    let active = 0, timer, visible = true;
    let paused = root.dataset.autoplay === 'false' || reduced.matches || !!window.Shopify?.designMode;
    const pause = root.querySelector('[data-studio-pause]'), counter = root.querySelector('[data-studio-counter]');
    const render = (announce = false) => {
      scenes.forEach((scene,index) => {scene.hidden = index !== active;scene.inert = index !== active;});
      root.querySelectorAll('[data-studio-go]').forEach((button,index) => {
        if (index === active) button.setAttribute('aria-current','true');else button.removeAttribute('aria-current');
      });
      if (counter) {counter.setAttribute('aria-live',announce?'polite':'off');counter.textContent=`Scene ${active+1} of ${scenes.length}`;}
      if (pause) {pause.textContent=paused?'Play':'Pause';pause.setAttribute('aria-label',paused?'Play automatic slideshow':'Pause automatic slideshow');}
    };
    const schedule = () => {
      clearInterval(timer);
      if (!paused && visible && !document.hidden) timer=setInterval(()=>{active=(active+1)%scenes.length;render();},Math.max(5000,Number(root.dataset.duration)||8000));
    };
    const go = (index,announce = true) => {active=(index+scenes.length)%scenes.length;render(announce);schedule();};
    root.querySelector('[data-studio-prev]')?.addEventListener('click',()=>go(active-1),options);
    root.querySelector('[data-studio-next]')?.addEventListener('click',()=>go(active+1),options);
    root.querySelectorAll('[data-studio-go]').forEach(button=>button.addEventListener('click',()=>go(Number(button.dataset.studioGo)),options));
    pause?.addEventListener('click',()=>{paused=!paused;render();schedule();},options);
    root.addEventListener('focusin',()=>{paused=true;render();schedule();},options);
    root.addEventListener('shopify:block:select',event=>{const work=event.target.closest('[data-studio-work]');if(work){paused=true;go(Number(work.dataset.scene)-1);}},options);
    root.addEventListener('pointermove',event=>{
      if (reduced.matches || event.pointerType==='touch') return;
      const box=root.getBoundingClientRect();
      root.style.setProperty('--sl-x',`${((event.clientX-box.left)/box.width-.5)*8}px`);
      root.style.setProperty('--sl-y',`${((event.clientY-box.top)/box.height-.5)*5}px`);
    },options);
    root.addEventListener('pointerleave',()=>{root.style.setProperty('--sl-x','0px');root.style.setProperty('--sl-y','0px');},options);
    document.addEventListener('visibilitychange',schedule,options);
    reduced.addEventListener('change',()=>{if(reduced.matches)paused=true;render();schedule();},options);
    const observer = new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:.15});
    observer.observe(root);
    document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root)){clearInterval(timer);observer.disconnect();abort.abort();}},{signal:abort.signal});
    render();schedule();
  };
  const run = scope => scope.querySelectorAll('[data-studio-hero]').forEach(boot);
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',()=>run(document),{once:true});else run(document);
  document.addEventListener('shopify:section:load',event=>run(event.target));
})();
